'use client'
import Link from 'next/link'
import Image from 'next/image'
import { useCampaign } from '@shared/hooks/useCampaign'
import { EVENTS, trackEvent } from 'helpers/analyticsHelper'
import { usePathname } from 'next/navigation'
import { Campaign } from 'helpers/types'

const ProBadge = (): React.JSX.Element => (
  <div
    className="
      pro-label
      font-semibold
      border
      border-gray-900
      rounded
      ml-2
      h-fit
      text-[10px]
      tracking-widest
      p-1
    "
  >
    PRO
  </div>
)

export const HeaderLogo = (): React.JSX.Element => {
  const [campaign] = useCampaign()
  const pathname = usePathname()

  const { isPro } = (campaign as Campaign | null) || {}

  return (
    <>
      <Link
        className="flex items-center no-underline"
        href="/dashboard"
        id="nav-logo"
        onClick={() =>
          trackEvent(EVENTS.Navigation.Top.ClickLogo, { pathname })
        }
      >
        <Image
          src="/images/logo/heart.svg"
          data-cy="logo"
          width={30}
          height={24}
          alt="GoodParty.org"
          priority
        />
        {isPro && <ProBadge />}
      </Link>
    </>
  )
}
